export default __webpack_public_path__ + "static/media/beat-the-peak-carousel-new.d97ded44.jpg";